import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import * as S from './FloatingWhatsApp.styles';

const PHONE_NUMBER = '+56992247167';

const FloatingWhatsApp: React.FC = () => {
  const handleClick = () => {
    const message = encodeURIComponent('Hola, me gustaría agendar una consulta con la Dra. Suni.');
    window.open(`https://wa.me/${PHONE_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <S.Container>
      <S.Button
        onClick={handleClick}
        aria-label="Contactar por WhatsApp"
        title="Contactar por WhatsApp"
      >
        <FaWhatsapp />
      </S.Button>
    </S.Container>
  );
};

export default FloatingWhatsApp;
